'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["open", "options", "placement", "tooltip", "value", "disabled"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import UIAbstractIconDropdown from './abstract/UIAbstractIconDropdown';
import SimpleStyledClickable from './internal/SimpleStyledClickable';
import Controllable from 'UIComponents/decorators/Controllable';
import UITextToolbarIcon from '../editor/UITextToolbarIcon';
import { SingleValueType } from 'UIComponents/types/OptionTypes';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
class UITextToolbarIconDropdownCore extends Component {
  render() {
    const _this$props = this.props,
      {
        open,
        options,
        placement,
        tooltip,
        value: currentValue,
        disabled
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const selectedOption = options.find(({
      value
    }) => value === currentValue);
    const renderedIcon = selectedOption ? /*#__PURE__*/_jsx(UITextToolbarIcon, {
      name: selectedOption.icon,
      disabled: disabled
    }) : null;
    return /*#__PURE__*/_jsx(UITooltip, {
      open: open ? false : undefined,
      placement: placement,
      title: tooltip,
      disabled: disabled,
      children: /*#__PURE__*/_jsx(UIAbstractIconDropdown, Object.assign({
        Button: SimpleStyledClickable,
        buttonText: renderedIcon,
        open: open,
        options: options,
        value: currentValue,
        disabled: disabled
      }, rest))
    });
  }
}
UITextToolbarIconDropdownCore.propTypes = {
  defaultValue: SingleValueType,
  onChange: PropTypes.func,
  onOpenChange: PropTypes.func,
  open: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    icon: UITextToolbarIcon.propTypes.name,
    value: SingleValueType
  }).isRequired).isRequired,
  placement: UITooltip.propTypes.placement,
  tooltip: UITooltip.propTypes.title,
  value: SingleValueType,
  disabled: PropTypes.bool
};
UITextToolbarIconDropdownCore.defaultProps = {
  open: false,
  placement: 'bottom'
};
UITextToolbarIconDropdownCore.displayName = 'UITextToolbarIconDropdownCore';
const UITextToolbarIconDropdown = Controllable(UITextToolbarIconDropdownCore, ['open', 'value']);
UITextToolbarIconDropdown.displayName = 'UITextToolbarIconDropdown';
export default UITextToolbarIconDropdown;